export default {
      id: "redo-usage",
      viewBox: "0 0 70 50",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#redo",
      toString: function () {
        return this.url;
      }
    }